import { useCallback } from 'react';

import { useTelemetry } from '@order/Telemetry';

import { useSetDefaultPaymentMethodMutation } from './GraphQL/DefaultPaymentMethod.generated';

export const useSetDefaultPaymentMethod = () => {
  const { track } = useTelemetry();
  const [, setDefaultPaymentMethod] = useSetDefaultPaymentMethodMutation();

  return useCallback(
    async (paymentMethodId: string) => {
      const response = await setDefaultPaymentMethod({ paymentMethodId });

      const defaultCardId = response.data?.setDefaultPaymentMethod?.defaultCardId;

      track('customer-sheet.stripe-usage', { defaultCardId });
    },
    [track, setDefaultPaymentMethod],
  );
};
